import React from 'react';
import AiAgent from './AiAgent';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {getImages} from '../../utills/lib'; // Ensure this utility function is correctly imported

function AiAgentMap({results}) {
  const navigate = useNavigate();
  const {  processedDocumentsListLoading,processedDocumentsDetailsLoading } = useSelector((state) => state.LoadAIAgentsSlice);

  const Agentlist = () => {
    if (results?.length === 0) {
      return <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', marginTop: '16px' }}>No activities found</p>;
    }

    return (
      <div>
        {results?.map((field) => (
          <AiAgent
            key={field.id}
            backgroundColor={field.backgroundColor}
            image={getImages(field?.system_ai_agent_slug)}
            title={field.input_file_name} 
            subtitle={field.ai_agent}
            status={field?.status}
            onClick={() => navigate('/ActivityDetailsScreen',{state:{field}})}
            className="agent-container"
          />
        ))}
      </div>
    );
  };

  return (
    <div>
      <div className="agent-list-container">
        {processedDocumentsListLoading || processedDocumentsDetailsLoading && [...Array(10)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width={200}
            height={120}
            sx={{ borderRadius: "8px", marginBottom: "16px" }}
          />
        ))}
      </div>
      <Agentlist />
    </div>
  );
}

export default AiAgentMap;
